"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modal_1 = require("../modules/modal");
var STYLES = {
    CONTENT: [
        'flex',
        'items-center',
        'size-full',
        'max-h-[60vh]',
        'max-w-[62.5vw]',
        'bg-white',
        'max-md:mx-4',
        'max-md:max-w-[50%]',
        'max-md:max-h-auto',
    ],
    IMAGE_CONTAINER: ['flex', 'flex-column', 'justify-center', 'items-center', 'gap-10', 'size-full', 'max-md:px-4'],
    IMAGE: ['w-full', 'max-w-[400px]', 'max-md:max-w-[400px]'],
    BUTTON: ['p-3.5', 'bg-light_black', 'rounded', 'text-white', 'text-sm', 'transition-opacity', 'hover:opacity-55'],
};
var CLOSE_BUTTON_CLASS = 'modal-close-btn';
var strategy = {
    createContents: function (button) {
        var originalImg = button.querySelector('img');
        var imgSrc = originalImg === null || originalImg === void 0 ? void 0 : originalImg.getAttribute('src');
        var imgAlt = originalImg === null || originalImg === void 0 ? void 0 : originalImg.getAttribute('alt');
        var url = button.getAttribute('data-url');
        var contentsTemplate = "\n      <div class=\"".concat(STYLES.CONTENT.join(' '), " relative\">\n        <button type=\"button\" class=\"").concat(CLOSE_BUTTON_CLASS, " absolute top-6 right-6 text-2xl text-light_black font-bold z-10\">&times;</button>\n        <div class=\"").concat(STYLES.IMAGE_CONTAINER.join(' '), "\">\n          <img class=\"").concat(STYLES.IMAGE.join(' '), "\" src=\"").concat(imgSrc, "\" alt=\"").concat(imgAlt, "\" />\n          <a href=\"").concat(url, "\" class=\"").concat(STYLES.BUTTON.join(' '), "\">\u30E9\u30D9\u30EB\u306E\u8A73\u7D30\u3092\u898B\u308B</a>\n        </div>\n      </div>\n    ");
        return contentsTemplate;
    },
};
var modal = new modal_1.Modal(strategy);
// 追加: モーダルのcloseボタンで閉じる処理
document.addEventListener('click', function (e) {
    var target = e.target;
    if (target.classList.contains(CLOSE_BUTTON_CLASS)) {
        // Modalクラスのclose()を呼び出す
        if (modal && typeof modal['close'] === 'function') {
            modal['close']();
        }
    }
});
